import * as yup from 'yup';

export const DOCUMENT_TYPES = [
  'Dealer License',
  'Business License',
  'Sales Tax Certificate',
  'W-9',
  'Voided check or bank letter verifying your ACH routing number',
  'Other',
];

export const dealerDocumentInitialValues: any = {
  dealerId: '',
  dealerName: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  description: '',
  date: new Date(),
  requestedDocuments: [{ documentType: '', description: '', otherDocumentType: '' }],
};

export const DealerDocumentSchemaYup = yup.object().shape({
  dealerName: yup.string().required('Dealer name is required'),
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  phone: yup.string().required('Phone is required'),
  description: yup.string().optional(),
  date: yup.date().required('Date is required'),
  requestedDocuments: yup.array().of(
    yup.object().shape({
      documentType: yup.string().required('Document type is required'),
      otherDocumentType: yup
        .string()
        .test('required-if-other', 'Please specify what document this is', function (value) {
          const { documentType } = this.parent;
          if (documentType === 'Other') {
            return Boolean(value && value.trim().length > 0);
          }
          return true;
        }),
      description: yup.string().optional(),
    })
  ),
});
